/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    exclude: {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" d="M0 2a2 2 0 012-2h8a2 2 0 012 2v2h2a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2v-2H2a2 2 0 01-2-2zm12 2H5a1 1 0 00-1 1v7h7a1 1 0 001-1z"/>',
    },
});
